module.exports = __webpack_public_path__ + "img/d5sj-btn.5d492536.png";